export namespace EinlasskontrolleConfigTypes {
    export const EINLASSKONTROLLE_MANDANT_OPTIONS = 'einlasskontrolle';
    
}

